import {createAsyncThunk} from '@reduxjs/toolkit';

import {workerService} from 'api/worker';
import {CompanyModel} from 'shared/models/company';
import {AppThunk} from 'store';
import {profileActionTypes} from './profileActions';

export const loadWorkerCompanyWorkers = createAsyncThunk('worker/getWorkerCompanyWorkers', async (workerId: string) => {
  return await workerService.getWorkerCompanyWorkers(workerId);
});

export const loadWorker = (workerId: string): AppThunk<Promise<void>> => {
  return async (dispatch) => {
    const worker = await workerService.getWorkerById(workerId);
    dispatch(profileActionTypes.setWorker(worker));
  };
};

export const loadWorkerCompanies = (workerId: string): AppThunk<Promise<CompanyModel[]>> => {
  return async (dispatch) => {
    const companies = await workerService.getWorkerCompanies(workerId);
    dispatch(profileActionTypes.setWorkerCompanies(companies));
    return companies;
  };
};
